export const PopupTypes = {
  GameRules: 'GameRules',
  Fairness: 'Fairness',
  Calculator: 'Calculator',
  HotKeys: 'HotKeys',
  AboutHash: 'AboutHash',
  Deposit: 'Deposit',
};
